/*
 * MERCADO 2.0 — collection & search results: filter drawer, sort, in-stock chip, AJAX re-render,
 * load more, description fold. Vanilla JS, no jQuery. Works with snippets/mc2-facets.liquid and
 * any section root marked [data-mc2-results-section][data-section-id].
 * Without JS everything is a normal link / GET form (Shopify storefront filtering URLs).
 */
(function () {
  if (window.MC2 && window.MC2.results) return;
  window.MC2 = window.MC2 || {};

  var root = function () { return document.querySelector('[data-mc2-results-section]'); };
  var cache = new Map();
  var busy = 0;

  function legacyPrev() {
    /* assets/facets.js (legacy, still loaded by header-js) listens to popstate and crashes if state
       differs from its own last value. Keep its value in our history entries so it stays idle. */
    try { return typeof FacetFiltersForm !== 'undefined' ? FacetFiltersForm.searchParamsPrev : undefined; } catch (e) { return undefined; }
  }

  function paramsFromForm(form) {
    var fd = new FormData(form);
    var p = new URLSearchParams();
    fd.forEach(function (v, k) { if (String(v).trim() !== '') p.append(k, v); });
    return p;
  }

  function currentParams() {
    var p = new URLSearchParams(window.location.search);
    p.delete('page'); p.delete('section_id');
    return p;
  }

  /* ---------- sold out (review E-05, snippets/mc2-soldout-state) ----------
     Every product is in the DOM; .mc2-sold-item cards and .mc2-sold-on counts show only while <html> has
     .mc2-show-sold. ?show_soldout=1 is the state in the URL: snippets/mc2-soldout-boot reads it before paint, the
     toggle flips it in place (no refetch), and every fetch / history entry below keeps it. */
  function soldOn() { return document.documentElement.classList.contains('mc2-show-sold'); }
  function withSold(search) {
    var p = new URLSearchParams(String(search || '').replace(/^\?/, ''));
    p.delete('show_soldout');
    if (soldOn()) p.set('show_soldout', '1');
    return p.toString();
  }
  function syncSold() {
    var on = soldOn();
    document.querySelectorAll('[data-mc2-soldtoggle]').forEach(function (b) {
      b.hidden = false;
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    document.querySelectorAll('[data-mc2-pager] a[href]').forEach(function (a) {
      var u = new URL(a.getAttribute('href'), window.location.origin);
      var s = withSold(u.search);
      a.setAttribute('href', u.pathname + (s ? '?' + s : '') + u.hash);
    });
  }
  function setSold(on, push) {
    document.documentElement.classList.toggle('mc2-show-sold', !!on);
    syncSold();
    if (push) {
      var s = withSold(window.location.search);
      history.pushState({ mc2: s, searchParams: legacyPrev() }, '', window.location.pathname + (s ? '?' + s : ''));
    }
  }

  function sectionUrl(search, sid) {
    var p = new URLSearchParams(search);
    p.delete('section_id');
    p.set('section_id', sid);
    return window.location.pathname + '?' + p.toString();
  }

  function fetchSection(search) {
    var r = root();
    if (!r) return Promise.reject();
    var url = sectionUrl(search, r.dataset.sectionId);
    if (cache.has(url)) return Promise.resolve(cache.get(url));
    return fetch(url, { credentials: 'same-origin' }).then(function (res) {
      if (!res.ok) throw new Error('HTTP ' + res.status);
      return res.text();
    }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var next = doc.querySelector('[data-mc2-results-section]');
      if (!next) throw new Error('no section');
      cache.set(url, next);
      return next;
    });
  }

  function swap(sel, next, cur) {
    var a = cur.querySelector(sel), b = next.querySelector(sel);
    if (a && b) { a.replaceWith(b.cloneNode(true)); return true; }
    return !a && !b;
  }

  function syncHeaderChip(search) {
    var on = new URLSearchParams(search).getAll('filter.v.availability').indexOf('1') > -1;
    document.querySelectorAll('[data-mc2-colhead] [data-mc2-instock]').forEach(function (chip) {
      var p = new URLSearchParams(search);
      p.delete('page');
      var vals = p.getAll('filter.v.availability').filter(function (v) { return v !== '1'; });
      p.delete('filter.v.availability');
      vals.forEach(function (v) { p.append('filter.v.availability', v); });
      if (!on) p.append('filter.v.availability', '1');
      var qs = p.toString();
      chip.href = window.location.pathname + (qs ? '?' + qs : '');
      chip.classList.toggle('is-active', on);
      chip.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function render(next, opts) {
    var cur = root();
    if (!cur) return;
    var dialog = cur.querySelector('[data-mc2-facets]');
    var keepDialog = opts && opts.keepDialog && dialog && dialog.open && next.querySelector('[data-mc2-facets]');

    if (keepDialog) {
      /* drawer stays open: update its body (keep open groups + scroll), the apply count, and the page behind */
      var open = {};
      dialog.querySelectorAll('details[data-mc2-key]').forEach(function (d) { open[d.dataset.mc2Key] = d.open; });
      var body = dialog.querySelector('[data-mc2-facets-body]');
      var scroll = body ? body.scrollTop : 0;
      var focusId = document.activeElement && dialog.contains(document.activeElement) ? document.activeElement.id : null;
      swap('[data-mc2-facets-body]', next, cur);
      swap('[data-mc2-apply-label]', next, cur);
      dialog.querySelectorAll('details[data-mc2-key]').forEach(function (d) { if (d.dataset.mc2Key in open) d.open = open[d.dataset.mc2Key]; });
      body = dialog.querySelector('[data-mc2-facets-body]');
      if (body) body.scrollTop = scroll;
      if (focusId) { var f = document.getElementById(focusId); if (f) f.focus({ preventScroll: true }); }
      swap('[data-mc2-toolbar]', next, cur);
      swap('[data-mc2-pills]', next, cur);
      swap('[data-mc2-results]', next, cur);
    } else {
      if (dialog && dialog.open) closeDrawer(dialog);
      cur.innerHTML = next.innerHTML;
    }
    cur.classList.remove('is-loading');
    document.dispatchEvent(new CustomEvent('mc2:results:updated', { detail: { section: cur } }));
  }

  function go(search, opts) {
    opts = opts || {};
    var r = root();
    if (!r) return;
    search = withSold(search);
    var my = ++busy;
    r.classList.add('is-loading');
    fetchSection(search).then(function (next) {
      if (my !== busy) return;
      render(next, opts);
      if (opts.push !== false) {
        var url = window.location.pathname + (search ? '?' + search : '');
        history.pushState({ mc2: search, searchParams: legacyPrev() }, '', url);
      }
      syncHeaderChip(search);
      if (opts.scroll) {
        var top = root().getBoundingClientRect().top + window.scrollY - 80;
        if (window.scrollY > top) window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      }
    }).catch(function () {
      /* network / parse failure: fall back to a full page load */
      window.location.search = search;
    });
  }

  /* ---------- drawer ---------- */
  var lastTrigger = null;
  function openDrawer(dialog, trigger) {
    lastTrigger = trigger || null;
    if (typeof dialog.showModal === 'function') dialog.showModal(); else dialog.setAttribute('open', '');
    document.documentElement.classList.add('mc2-scroll-lock');
    dialog.dataset.mc2Start = new URLSearchParams(window.location.search).toString();
  }
  function closeDrawer(dialog) {
    if (typeof dialog.close === 'function' && dialog.open) dialog.close(); else dialog.removeAttribute('open');
    document.documentElement.classList.remove('mc2-scroll-lock');
    if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus({ preventScroll: true });
  }

  var debounceTimer = null;
  function onFormInput(form, immediate) {
    clearTimeout(debounceTimer);
    var run = function () {
      var p = paramsFromForm(form);
      go(p.toString(), { keepDialog: true, push: true });
    };
    if (immediate) run(); else debounceTimer = setTimeout(run, 350);
  }

  /* ---------- load more ---------- */
  function loadMore(link) {
    var r = root();
    if (!r || link.classList.contains('is-loading')) return;
    link.classList.add('is-loading');
    var u = new URL(link.href, window.location.origin);
    u.search = withSold(u.search);
    fetchSection(u.search.slice(1)).then(function (next) {
      var grid = r.querySelector('[data-mc2-grid]');
      var ngrid = next.querySelector('[data-mc2-grid]');
      if (grid && ngrid) {
        Array.prototype.forEach.call(ngrid.children, function (li) { grid.appendChild(li.cloneNode(true)); });
      }
      swap('[data-mc2-pager]', next, r);
      var p = new URLSearchParams(u.search); p.delete('section_id');
      history.replaceState({ mc2: p.toString(), searchParams: legacyPrev() }, '', window.location.pathname + '?' + p.toString());
      document.dispatchEvent(new CustomEvent('mc2:results:updated', { detail: { section: r } }));
    }).catch(function () { window.location.href = link.href; });
  }

  /* ---------- description fold ---------- */
  function initDesc() {
    document.querySelectorAll('[data-mc2-desc]').forEach(function (d) {
      var b = d.parentNode.querySelector('[data-mc2-more]');
      if (!b || b.dataset.ready) return;
      b.dataset.ready = '1';
      if (d.scrollHeight - d.clientHeight > 4) b.hidden = false;
      b.addEventListener('click', function () {
        var open = d.classList.toggle('is-open');
        b.setAttribute('aria-expanded', open ? 'true' : 'false');
        b.textContent = open ? b.dataset.less : b.dataset.more;
      });
    });
  }

  /* ---------- events (delegated: survive re-renders) ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!(t instanceof Element)) return;
    var r = root();

    var opener = t.closest('[data-mc2-open-facets]');
    if (opener) {
      var d = document.getElementById(opener.getAttribute('aria-controls'));
      if (d) { e.preventDefault(); openDrawer(d, opener); }
      return;
    }
    if (t.closest('[data-mc2-close]')) {
      var dlg = t.closest('dialog');
      if (dlg) { e.preventDefault(); closeDrawer(dlg); }
      return;
    }
    if (t.matches('dialog[data-mc2-facets]')) { closeDrawer(t); return; } /* backdrop */

    var more = t.closest('[data-mc2-show-all]');
    if (more) {
      var fs = more.closest('[data-mc2-values]');
      if (fs) fs.classList.add('is-all');
      more.remove();
      return;
    }
    var soldBtn = t.closest('[data-mc2-soldtoggle]');
    if (soldBtn) { e.preventDefault(); setSold(!soldOn(), true); return; }
    if (!r || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;

    var lm = t.closest('[data-mc2-load-more]');
    if (lm && r.contains(lm)) { e.preventDefault(); loadMore(lm); return; }

    var link = t.closest('[data-mc2-facet-link], [data-mc2-instock], [data-mc2-pager] a');
    if (link && link.href) {
      var u = new URL(link.href, window.location.origin);
      if (u.pathname !== window.location.pathname) return;
      e.preventDefault();
      var inPager = !!link.closest('[data-mc2-pager]');
      go(u.search.slice(1), { scroll: inPager || !!link.closest('[data-mc2-colhead]') });
    }
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!(t instanceof Element)) return;
    if (t.matches('[data-mc2-sort]')) {
      var form = document.getElementById(t.getAttribute('form'));
      if (!form) return;
      var p = paramsFromForm(form);
      p.set('sort_by', t.value);
      go(p.toString(), {});
      return;
    }
    var f = t.closest('[data-mc2-facets-form]');
    if (f) onFormInput(f, t.type === 'checkbox');
  });

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!(f instanceof HTMLFormElement) || !f.matches('[data-mc2-facets-form]')) return;
    e.preventDefault();
    clearTimeout(debounceTimer);
    var p = paramsFromForm(f);
    var dlg = f.closest('dialog');
    var target = withSold(p.toString());
    if (target === new URLSearchParams(window.location.search).toString()) {
      if (dlg) closeDrawer(dlg);
      return;
    }
    go(target, { scroll: true });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target instanceof HTMLInputElement && e.target.type === 'number' && e.target.closest('[data-mc2-facets-form]')) {
      e.preventDefault();
      onFormInput(e.target.form, true);
    }
  });

  document.addEventListener('close', function (e) {
    if (e.target instanceof HTMLDialogElement && e.target.matches('[data-mc2-facets]')) {
      document.documentElement.classList.remove('mc2-scroll-lock');
    }
  }, true);

  window.addEventListener('popstate', function (e) {
    if (!root()) return;
    var s = (e.state && typeof e.state.mc2 === 'string') ? e.state.mc2 : window.location.search.slice(1);
    setSold(new URLSearchParams(s).get('show_soldout') === '1', false);
    go(s, { push: false });
  });

  /* sticky toolbar sits under the sticky site header (if any) */
  function stickyOffset() {
    if (document.querySelector('[data-mc2-header]')) return; /* the MC2 header keeps --mc2-sticky-top in sync itself */
    var h = document.querySelector('.site-header--sticky') || document.querySelector('#shopify-section-header');
    var off = 0;
    if (h) {
      var el = h.closest('.shopify-section') || h;
      var pos = getComputedStyle(el).position;
      if (pos === 'sticky' || pos === 'fixed' || getComputedStyle(h).position === 'sticky' || getComputedStyle(h).position === 'fixed') off = Math.round(h.getBoundingClientRect().height);
    }
    document.documentElement.style.setProperty('--mc2-sticky-top', off + 'px');
  }
  function init() {
    if (new URLSearchParams(window.location.search).get('show_soldout') === '1') document.documentElement.classList.add('mc2-show-sold');
    initDesc(); stickyOffset(); syncSold();
  }
  document.addEventListener('mc2:results:updated', syncSold);
  window.addEventListener('resize', function () { clearTimeout(stickyOffset.t); stickyOffset.t = setTimeout(stickyOffset, 150); });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', initDesc);

  window.MC2.results = { go: go, refresh: function () { go(window.location.search.slice(1), { push: false }); } };
})();
